module.exports = __webpack_public_path__ + "static/media/LI12.2e0037a0.jpg";